// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistemaFranquia_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface ConfiguracoesSistemaFranquia_SaveResponseDados {
config_sistema_id: number
}

export type ConfiguracoesSistemaFranquia_SaveResponse = ApiResponse<ConfiguracoesSistemaFranquia_SaveResponseDados>;

registerResponseContract('ConfiguracoesSistemaFranquia_SaveResponse', {
  config_sistema_id: { type: 'number',  required: true },
})
